var counter = 0;
var maxAttempts = 10;
var interval = 1000;

var labelsRender = document.querySelectorAll(".rendered-form label");

function callFunctionRepeatedly() {
  labelsRender = document.querySelectorAll(".rendered-form label");
  var labels = document.querySelectorAll(".field label, .rendered-form label");
  var inputs = document.querySelectorAll(".field input, .rendered-form input");
  var filteredLabels = Array.from(labels).filter(
    (label) =>
      !(
        label.classList.contains("formbuilder-select-label") ||
        label.classList.contains("formbuilder-textarea-label") ||
        label.classList.contains("formbuilder-autocomplete-label")
      )
  );
  var filteredInputs = Array.from(inputs).filter(
    (input) => !input.classList.contains("country-field")
  );
  function updateLabelStyle(input, label) {
    console.log(input, label);
    if (input.value.trim() !== "" || input === document.activeElement) {
      label.style.top = "6px";
      label.style.fontSize = "10px";

      input.style.padding = "20px 15px 10px 14px";
    } else {
      label.style.top = "16px";
      label.style.fontSize = "16px";

      input.style.padding = "15px";
    }
  }
  filteredInputs.forEach((input, index) => {
    input.addEventListener("input", () =>
      updateLabelStyle(input, filteredLabels[index])
    );
    input.addEventListener("focus", () =>
      updateLabelStyle(input, filteredLabels[index])
    );
    input.addEventListener("blur", () =>
      updateLabelStyle(input, filteredLabels[index])
    );
  });

  function hideLabel(ele) {
    const label = ele.previousElementSibling;
    if (label) {
      if (ele.value.trim() !== "") {
        label.style.display = "none";
      } else {
        label.style.display = "unset";
      }
    }
  }
  const textAeras = document.querySelectorAll(".rendered-form textarea");
  if (textAeras.length) {
    textAeras.forEach((textAera) => {
      textAera.addEventListener("input", () => hideLabel(textAera));
      textAera.addEventListener("focus", () => hideLabel(textAera));
      textAera.addEventListener("blur", () => hideLabel(textAera));
    });
  }

  const textCountry = document.querySelector(".rendered-form .country-field");
  function styleForCoutryField(input) {
    const label = input.previousElementSibling;
    if (
      label &&
      input.nextElementSibling &&
      input.nextElementSibling.value.trim() !== ""
    ) {
      label.style.top = "6px";
      label.style.fontSize = "10px";

      input.style.padding = "20px 15px 10px 14px";
    } else {
      label.style.top = "16px";
      label.style.fontSize = "16px";

      input.style.padding = "15px";
    }
  }
  if (textCountry) {
    textCountry.addEventListener("input", () =>
      styleForCoutryField(textCountry)
    );
    textCountry.addEventListener("click", () =>
      setTimeout(() => {
        styleForCoutryField(textCountry);
      }, 100)
    );
    textCountry.addEventListener("blur", () =>
      setTimeout(() => {
        styleForCoutryField(textCountry);
      }, 200)
    );
  }

  if (labelsRender.length > 0 || counter >= maxAttempts) {
    console.log(inputs);
    console.log("Stopped calling function.");
    return;
  }
  counter++;
  setTimeout(callFunctionRepeatedly, interval);
}

document.addEventListener("DOMContentLoaded", function () {
  if (typeof BSS_B2B != undefined) {
    callFunctionRepeatedly();

      // fix cart change
    window.addEventListener("cart_changed", ()=>{
      setTimeout(() =>{
              let storeData = JSON.parse($("#bss-b2b-store-data").html());
              BSS_B2B.cart.fixer(storeData, null, false);
          }, 500)
    })

    //fix spam checkout
    setTimeout(() =>{
      function handleButtonClick(e) {
        const $button = $(this);/*  */
        let oldText = $(this).text();
        $button.css({'pointer-events': 'none', 'opacity': '0.6'});
        $button.text("Loading ...");
        setTimeout(() =>{
          $button.css({'pointer-events': 'unset', 'opacity': '1'})
            $button.text(oldText);
        }, 2000);
        
      }
     
     $(document).on('click dblclick', 'button[name="checkout"]', handleButtonClick);
    }, 500)
  }

  //fix quickview
  setTimeout(() =>{
    const quickView = document.querySelector(".modal");
    if (quickView) {
      const mutationObserver = new MutationObserver((recordList, observe) => {
          for (const record of recordList) {
          if (record.target.classList.contains("modal")) {
    				BSS_B2B.cp.changeProductPrice(JSON.parse($('#bss-b2b-store-data').html()), "[bss-b2b-product-id]", false, true);
            break;
          }
        }
      });
      mutationObserver.observe(quickView, { attributes: true });
    }
  }, 1500)
});